/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const objectivesHealthSummarySchema = z.object({
  averageProgressPercentage: z.int().nullish(),
  healthLevels: z.object({}).catchall(z.int()),
  total: z.int(),
});
